import React from 'react';
import { useTicketStats, useMilestone, useTicketGrouper } from '../../../lib/hooks';
import BurnDown from '../../perf/BurnDown';
import { SprintBacklog, TodaysProgress } from '../../widgets/SprintBacklog';
import Leads from './Leads';
import ProductBacklog from './ProductBacklog';
import MemberStats from '../../widgets/MemberStats';
import { BlogStatus } from '../../widgets/BlogStatus';
import { useSelector } from 'react-redux';

const Dashboard = () => {

    const { ticketListFiltered: ticketList, groupedList } = useTicketGrouper();
    const milestone = useMilestone();
    const {
        sprintStatus,
        completionStatus,
        tmTotal,
        prog,
        progVal
    } = useTicketStats(ticketList);
    const appConfig = useSelector(st => st.appConfig);

    const colorMap = {};
    if (!ticketList || !groupedList || !milestone) {
        return (
            <div className="ds-panel" style={{ padding: 'var(--ds-space-12)', textAlign: 'center' }}>
                <span className="ds-spinner" /> <span style={{ marginLeft: 8, color: 'var(--ds-ink-muted)' }}>Loading dashboard…</span>
            </div>
        );
    }

    const enabled = appConfig.sections.filter(item => item.module === 'dashboard' && item.enabled === 'TRUE');
    const enableBlog = enabled.some(item => item.value === 'blog-status');
    const enableBurnDown = enabled.some(item => item.value === 'sprint-burndown');
    const enableProductBacklog = enabled.some(item => item.value === 'product-backlog');
    const enableSprintBacklog = enabled.some(item => item.value === 'sprint-backlog');

    return (
        <div className="dash">
            <div className="dash__col is-a">
                <Leads statsList={groupedList} milestone={milestone.title} />
                {enableProductBacklog && <ProductBacklog ASSIGNMENTS={colorMap} />}
            </div>

            <div className="dash__col is-b">
                <TodaysProgress />
                {enableBlog && <BlogStatus userList={groupedList} />}
            </div>

            <div className="dash__col is-c">
                <MemberStats
                    statsList={groupedList}
                    milestone={milestone}
                    tmTotal={tmTotal}
                    prog={prog}
                    progVal={progVal} />
                {enableSprintBacklog && (
                    <SprintBacklog
                        sprintStatus={sprintStatus}
                        prog={prog}
                        milestone={milestone?.title}
                        ASSIGNMENTS={colorMap}
                        completionStatus={completionStatus} />
                )}
                {enableBurnDown && <BurnDown issueList={ticketList} />}
            </div>
        </div>
    );
};

export default Dashboard;
